import mixpanel from 'mixpanel-browser';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Header, HeaderContents } from '../RecordDetail/styles';
import { items } from './items';
import { Container, Desc, ItemContainer, ListContainer, Title } from './styles';

const MainList: React.FC = () => {
    useEffect(() => {
        mixpanel.track('ue16 page viewed');
    }, []);

    return (
        <Container>
            <Header>
                <HeaderContents className='main'>STIBEE</HeaderContents>
                <HeaderContents className='main'>UNLIMITED EDITION 16</HeaderContents>
            </Header>
            <Title>뉴스레터 발행인의 <br />목소리로 듣는 뉴스레터</Title>
            <Desc>마음에 드는 문구를 눌러 보세요</Desc>
            <ListContainer>
                {items.map((item) => {
                    const titleParts = item.title.split('/');

                    return (
                        <Link to={`/record/${item.key}`} key={item.key}>
                            <ItemContainer onClick={() => mixpanel.track('ue16 phrase button clicked', {
                                title: item.title.replace(/\//g, ' '),
                            })}>
                                {titleParts.map((part, index) => (
                                    <React.Fragment key={index}>
                                        {part}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </ItemContainer>
                        </Link>
                    )
                })}
            </ListContainer>
            <img style={{ width: 130, paddingTop: 46, paddingBottom: 46 }} src='/icons/stb_logo.png' alt='stb_logo' />
        </Container>
    );
};

export default MainList;
